import { Popconfirm } from "antd";
import { APP_ROUTES, MAIN_ROUTES } from "../../../_config/routes";

export function DropdownClient({ clientName, clientUuid }) {

    const gotToLinkByClient = (link, client) => {
        let a = document.createElement('A');
        a.href = `${link}?client=${client}`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const goToClientOrderStates = () => {
        gotToLinkByClient(`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_live}`, clientUuid);        
    }

    const goToClientDeaprtures = () => {
        gotToLinkByClient(`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_departures}`, clientUuid);        
    }

    return(
        <Popconfirm
            title="¿A dónde quieres ir?"
            description="¿A dónde quieres ir?"
            onConfirm={goToClientDeaprtures}
            onCancel={goToClientOrderStates}
            okText="Despachos"
            cancelText="Estado del pedido"
        >
            <span style={{ fontWeight: 'bold', margin: '0 8px', cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}>{clientName}</span>
        </Popconfirm>
    );
}